<template>
<!-- 主题海报图样式 -->
  <div
    id="jingdianyulePic"
    class="jingdianyulePic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
  <div class="jingdianyuleContent">
    <div class="recommendTheme" v-if="jingdianRecommend ">
      <span  class="label white">景点推荐:</span>
      <span  class="value white" v-html="jingdianRecommend"></span>
    </div> 
    <div class="optionTheme" v-if="yuleRecommend">
      <span  class="label white">娱乐推荐:</span>
      <span  class="value white" v-html="yuleRecommend"></span>
    </div> 
  </div>
 
  </div>
</template>

<script>
export default {
  name: "jingdianyulePic",
  data() {
    return {
      loading: false
    };
  },
  props: ["backgroundPic","jingdianRecommend","yuleRecommend"],
  methods: {
  },

  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
#jingdianyulePic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}

.jingdianyuleContent{
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 440px;
  width: 100%;
}
.jingdianyuleContent > div{
  line-height: 30px;
}

.white{
  color: #fff;
}


</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/jingdianyulePic.vue